<button
    [type]="type"
    mat-raised-button
    color="accent"
    [disabled]="disabled || busy"
>
    @if (busy) {
    <mat-icon>
        <mat-spinner diameter="20"></mat-spinner>
    </mat-icon>
    }
    {{ text }}
</button>
